import {
  action_api_set_input as action_api_set_input_OturumAc,
  action_api_reset_store as action_api_reset_store_OturumAc,
  action_async_start as action_async_start_promise_OturumAc,
  action_async_complete as action_async_complete_api_OturumAc,
} from './container/api/user/OturumAcAction';
import {
  action_async_start as action_async_start_promise_OturumKapat,
  action_async_complete as action_async_complete_api_OturumKapat,
} from './container/api/user/OturumKapatAction';
import {
  action_api_set_input as action_api_set_input_KullaniciKontrol,
  action_async_start as action_async_start_promise_KullaniciKontrol,
  action_async_complete as action_async_complete_api_KullaniciKontrol,
} from './container/api/user/KullaniciKontrolAction';
import {
  action_api_set_input as action_api_set_input_OtpAl,
  action_async_start as action_async_start_promise_OtpAl,
  action_async_complete as action_async_complete_api_OtpAl,
} from './container/api/user/OtpAlAction';
import {
  action_api_set_input as action_api_set_input_OtpKontrol,
  action_async_start as action_async_start_promise_OtpKontrol,
  action_async_complete as action_async_complete_api_OtpKontrol,
} from './container/api/user/OtpKontrolAction';

import {
  action_api_set_input as action_api_set_input_SifremiUnuttum,
  action_async_start as action_async_start_promise_SifremiUnuttum,
  action_async_complete as action_async_complete_api_SifremiUnuttum,
} from './container/api/user/SifremiUnuttumAction';

import {
  action_api_set_input as action_api_set_input_SifreDegistir,
  action_async_start as action_async_start_promise_SifreDegistir,
  action_async_complete as action_async_complete_api_SifreDegistir,
} from './container/api/user/SifreDegistirAction';

import {
  action_api_set_input as action_api_set_input_UiVersionKontrol,
  action_async_start as action_async_start_promise_UiVersionKontrol,
  action_async_complete as action_async_complete_api_UiVersionKontrol,
} from './container/api/user/UiVersionKontrolAction';

import {
  action_async_start as action_async_start_promise_SorguInputlari,
  action_async_complete as action_async_complete_api_SorguInputlari,
} from './container/api/veri/SorguInputlariAction';
import {
  action_async_start as action_async_start_promise_GrupSirketListele,
  action_async_complete as action_async_complete_api_GrupSirketListele,
} from './container/api/veri/GrupSirketListeleAction';
import {
  action_async_start as action_async_start_promise_FaaliyetAlaniListesi,
  action_async_complete as action_async_complete_api_FaaliyetAlaniListesi,
} from './container/api/veri/FaaliyetAlaniListesiAction';
import {
  action_async_start as action_async_start_promise_HaritadaAra,
  action_async_complete as action_async_complete_api_HaritadaAra,
} from './container/api/veri/HaritadaAraAction';
import {
  action_async_start as action_async_start_promise_ProjeListele,
  action_async_complete as action_async_complete_api_ProjeListele,
} from './container/api/veri/ProjeListeleAction';
import {
  action_async_start as action_async_start_promise_RaporUrlGetir,
  action_async_complete as action_async_complete_api_RaporUrlGetir,
} from './container/api/veri/RaporUrlGetirAction';
import {
  action_async_start as action_async_start_AnasayfaUstBilgi,
  action_async_complete as action_async_complete_AnasayfaUstBilgi,
} from './container/api/bilgi/AnasayfaUstBilgiAction';
import {
  action_async_start as action_async_start_FaaliyetAlaniUstBilgi,
  action_async_complete as action_async_complete_FaaliyetAlaniUstBilgi,
} from './container/api/bilgi/FaaliyetAlaniUstBilgiAction';
import {
  action_async_start as action_async_start_GrupSirketiUstBilgi,
  action_async_complete as action_async_complete_GrupSirketiUstBilgi,
} from './container/api/bilgi/GrupSirketiUstBilgiAction';
import {
  action_async_start as action_async_start_KiraGenelBilgi,
  action_async_complete as action_async_complete_KiraGenelBilgi,
} from './container/api/bilgi/KiraGenelBilgiAction';
import {
  action_async_start as action_async_start_KiraBilgi,
  action_async_complete as action_async_complete_KiraBilgi,
} from './container/api/bilgi/KiraBilgiAction';
import {
  action_async_start as action_async_start_MadenSahalariGenelBilgi,
  action_async_complete as action_async_complete_MadenSahalariGenelBilgi,
} from './container/api/bilgi/MadenSahalariGenelBilgiAction';
import {
  action_async_start as action_async_start_MadenSahalariBilgi,
  action_async_complete as action_async_complete_MadenSahalariBilgi,
} from './container/api/bilgi/MadenSahalariBilgiAction';
import {
  action_async_start as action_async_start_OyakGmCiroBazliListe,
  action_async_complete as action_async_complete_OyakGmCiroBazliListe,
} from './container/api/bilgi/OyakGmCiroBazliListeAction';
import {
  action_async_start as action_async_start_SorgulamaSonuclariListe,
  action_async_complete as action_async_complete_SorgulamaSonuclariListe,
} from './container/api/bilgi/SorgulamaSonuclariListeAction';
import {
  action_async_start as action_async_start_TiklamaSonuclariListe,
  action_async_complete as action_async_complete_TiklamaSonuclariListe,
} from './container/api/bilgi/TiklamaSonuclariListeAction';
import {
  action_async_start as action_async_start_OyakProjeToplamHakedisListe,
  action_async_complete as action_async_complete_OyakProjeToplamHakedisListe,
} from './container/api/bilgi/OyakProjeToplamHakedisListeAction';
import {
  action_async_start as action_async_start_OyakKiraBilgileriUstBilgi,
  action_async_complete as action_async_complete_OyakKiraBilgileriUstBilgi,
} from './container/api/bilgi/OyakKiraBilgileriUstBilgiAction';
import {
  action_async_start as action_async_start_GrupSirketDegerlemeUstBilgi,
  action_async_complete as action_async_complete_GrupSirketDegerlemeUstBilgi,
} from './container/api/bilgi/GrupSirketDegerlemeUstBilgiAction';
import {
  action_async_start as action_async_start_OyakDegerlemeUstBilgi,
  action_async_complete as action_async_complete_OyakDegerlemeUstBilgi,
} from './container/api/bilgi/OyakDegerlemeUstBilgiAction';
import {
  action_async_start as action_async_start_OyakKiraBilgileriUstBilgiKvtDetay,
  action_async_complete as action_async_complete_OyakKiraBilgileriUstBilgiKvtDetay,
} from './container/api/bilgi/OyakKiraBilgileriUstBilgiKvtDetayAction';
import {
  action_async_start as action_async_start_OyakKiraBilgileriUstBilgiYkgDetay,
  action_async_complete as action_async_complete_OyakKiraBilgileriUstBilgiYkgDetay,
} from './container/api/bilgi/OyakKiraBilgileriUstBilgiYkgDetayAction';
import {
  action_async_start as action_async_start_OyakKiraBilgileriUstBilgiAkgDetay,
  action_async_complete as action_async_complete_OyakKiraBilgileriUstBilgiAkgDetay,
} from './container/api/bilgi/OyakKiraBilgileriUstBilgiAkgDetayAction';
import {
  action_async_start as action_async_start_UstBilgiIstatistikDetay,
  action_async_complete as action_async_complete_UstBilgiIstatistikDetay,
} from './container/api/bilgi/UstBilgiIstatistikDetayAction';

import {
  action_async_start_promise as action_async_start_OyakEmlakVergileriDetayToplamDeger,
  action_async_complete_api as action_async_complete_OyakEmlakVergileriDetayToplamDeger,
} from './container/api/stat/OyakEmlakVergileriDetayToplamDegerAction';
import {
  action_api_set_input as action_api_set_input_GayrimenkulAlan,
  action_async_start_promise as action_async_start_promise_GayrimenkulAlan,
  action_async_complete_api as action_async_complete_api_GayrimenkulAlan,
} from './container/api/stat/GayrimenkulAlanAction';
import {
  action_api_set_input as action_api_set_input_GayrimenkulSayi,
  action_async_start_promise as action_async_start_promise_GayrimenkulSayi,
  action_async_complete_api as action_async_complete_api_GayrimenkulSayi,
} from './container/api/stat/GayrimenkulSayiAction';
import {
  action_api_set_input as action_api_set_input_GayrimenkulToplamDeger,
  action_async_start_promise as action_async_start_promise_GayrimenkulToplamDeger,
  action_async_complete_api as action_async_complete_api_GayrimenkulToplamDeger,
} from './container/api/stat/GayrimenkulToplamDegerAction';
import {
  action_api_set_input as action_api_set_input_KullanimAmacliGayrimenkulAlan,
  action_async_start_promise as action_async_start_promise_KullanimAmacliGayrimenkulAlan,
  action_async_complete_api as action_async_complete_api_KullanimAmacliGayrimenkulAlan,
} from './container/api/stat/KullanimAmacliGayrimenkulAlanAction';
import {
  action_api_set_input as action_api_set_input_KullanimAmacliGayrimenkulSayi,
  action_async_start_promise as action_async_start_promise_KullanimAmacliGayrimenkulSayi,
  action_async_complete_api as action_async_complete_api_KullanimAmacliGayrimenkulSayi,
} from './container/api/stat/KullanimAmacliGayrimenkulSayiAction';
import {
  action_api_set_input as action_api_set_input_KullanimAmacliGayrimenkulToplamDeger,
  action_async_start_promise as action_async_start_promise_KullanimAmacliGayrimenkulToplamDeger,
  action_async_complete_api as action_async_complete_api_KullanimAmacliGayrimenkulToplamDeger,
} from './container/api/stat/KullanimAmacliGayrimenkulToplamDegerAction';
import {
  action_api_set_input as action_api_set_input_YatirimAmacliGayrimenkulAlan,
  action_async_start_promise as action_async_start_promise_YatirimAmacliGayrimenkulAlan,
  action_async_complete_api as action_async_complete_api_YatirimAmacliGayrimenkulAlan,
} from './container/api/stat/YatirimAmacliGayrimenkulAlanAction';
import {
  action_api_set_input as action_api_set_input_YatirimAmacliGayrimenkulSayi,
  action_async_start_promise as action_async_start_promise_YatirimAmacliGayrimenkulSayi,
  action_async_complete_api as action_async_complete_api_YatirimAmacliGayrimenkulSayi,
} from './container/api/stat/YatirimAmacliGayrimenkulSayiAction';
import {
  action_api_set_input as action_api_set_input_YatirimAmacliGayrimenkulToplamDeger,
  action_async_start_promise as action_async_start_promise_YatirimAmacliGayrimenkulToplamDeger,
  action_async_complete_api as action_async_complete_api_YatirimAmacliGayrimenkulToplamDeger,
} from './container/api/stat/YatirimAmacliGayrimenkulToplamDegerAction';
import {
  action_api_set_input as action_api_set_input_DegerlemeToplamDeger,
  action_async_start_promise as action_async_start_promise_DegerlemeToplamDeger,
  action_async_complete_api as action_async_complete_api_DegerlemeToplamDeger,
} from './container/api/stat/DegerlemeToplamDegerAction';
import {
  action_api_set_input as action_api_set_input_OyakDegerlemeToplamDeger,
  action_async_start_promise as action_async_start_promise_OyakDegerlemeToplamDeger,
  action_async_complete_api as action_async_complete_api_OyakDegerlemeToplamDeger,
} from './container/api/stat/OyakDegerlemeToplamDegerAction';
import {
  action_api_set_input as action_api_set_input_OyakEmlakVergileri,
  action_async_start as action_async_start_OyakEmlakVergileri,
  action_async_complete as action_async_complete_OyakEmlakVergileri,
} from './container/api/stat/OyakEmlakVergileriAction';
import {
  action_page_loaded as action_page_loaded_Dashboard,
  action_page_unloaded as action_page_unloaded_Dashboard,
  action_page_props_sent as action_page_props_sent_Dashboard,
} from './container/page/DashboardAction';
import {
  action_page_loaded as action_page_loaded_DegerlemeBilgileri,
  action_page_unloaded as action_page_unloaded_DegerlemeBilgileri,
  action_page_props_sent as action_page_props_sent_DegerlemeBilgileri,
} from './container/page/DegerlemeBilgileriAction';
import {
  action_page_loaded as action_page_loaded_EmlakVergileri,
  action_page_unloaded as action_page_unloaded_EmlakVergileri,
  action_page_props_sent as action_page_props_sent_EmlakVergileri,
} from './container/page/EmlakVergileriAction';
import {
  action_page_loaded as action_page_loaded_FaaliyetAlani,
  action_page_unloaded as action_page_unloaded_FaaliyetAlani,
  action_page_props_sent as action_page_props_sent_FaaliyetAlani,
} from './container/page/FaaliyetAlaniAction';
import {
  action_page_loaded as action_page_loaded_FourOhFour,
  action_page_unloaded as action_page_unloaded_FourOhFour,
  action_page_props_sent as action_page_props_sent_FourOhFour,
} from './container/page/FourOhFourAction';
import {
  action_page_loaded as action_page_loaded_GayrimenkulAlan,
  action_page_unloaded as action_page_unloaded_GayrimenkulAlan,
  action_page_props_sent as action_page_props_sent_GayrimenkulAlan,
} from './container/page/GayrimenkulAlanAction';
import {
  action_page_loaded as action_page_loaded_GayrimenkulSayi,
  action_page_unloaded as action_page_unloaded_GayrimenkulSayi,
  action_page_props_sent as action_page_props_sent_GayrimenkulSayi,
} from './container/page/GayrimenkulSayiAction';
import {
  action_page_loaded as action_page_loaded_GayrimenkulToplamDeger,
  action_page_unloaded as action_page_unloaded_GayrimenkulToplamDeger,
  action_page_props_sent as action_page_props_sent_GayrimenkulToplamDeger,
} from './container/page/GayrimenkulToplamDegerAction';
import {
  action_page_loaded as action_page_loaded_GrupSirketi,
  action_page_unloaded as action_page_unloaded_GrupSirketi,
  action_page_props_sent as action_page_props_sent_GrupSirketi,
} from './container/page/GrupSirketiAction';
import {
  action_page_loaded as action_page_loaded_Harita,
  action_page_unloaded as action_page_unloaded_Harita,
  action_page_props_sent as action_page_props_sent_Harita,
} from './container/page/HaritaAction';
import {
  action_page_loaded as action_page_loaded_KiraBilgileri,
  action_page_unloaded as action_page_unloaded_KiraBilgileri,
  action_page_props_sent as action_page_props_sent_KiraBilgileri,
} from './container/page/KiraBilgileriAction';
import {
  action_page_loaded as action_page_loaded_Kisisel,
  action_page_unloaded as action_page_unloaded_Kisisel,
  action_page_props_sent as action_page_props_sent_Kisisel,
} from './container/page/KisiselAction';
import {
  action_page_loaded as action_page_loaded_Login,
  action_page_unloaded as action_page_unloaded_Login,
  action_page_props_sent as action_page_props_sent_Login,
} from './container/page/LoginAction';
import {
  action_page_loaded as action_page_loaded_MadenSahalari,
  action_page_unloaded as action_page_unloaded_MadenSahalari,
  action_page_props_sent as action_page_props_sent_MadenSahalari,
} from './container/page/MadenSahalariAction';
import {
  action_page_loaded as action_page_loaded_OyakGmCiroBazli,
  action_page_unloaded as action_page_unloaded_OyakGmCiroBazli,
  action_page_props_sent as action_page_props_sent_OyakGmCiroBazli,
} from './container/page/OyakGmCiroBazliAction';
import {
  action_page_loaded as action_page_loaded_SorgulamaSonuclari,
  action_page_unloaded as action_page_unloaded_SorgulamaSonuclari,
  action_page_props_sent as action_page_props_sent_SorgulamaSonuclari,
} from './container/page/SorgulamaSonuclariAction';
import {
  action_page_loaded as action_page_loaded_OyakProjeToplamHakedis,
  action_page_unloaded as action_page_unloaded_OyakProjeToplamHakedis,
  action_page_props_sent as action_page_props_sent_OyakProjeToplamHakedis,
} from './container/page/OyakProjeToplamHakedisAction';
import {
  action_page_loaded as action_page_loaded_OyakProjeYilBazliToplamHakedis,
  action_page_unloaded as action_page_unloaded_OyakProjeYilBazliToplamHakedis,
  action_page_props_sent as action_page_props_sent_OyakProjeYilBazliToplamHakedis,
} from './container/page/OyakProjeYilBazliToplamHakedisAction';
import {
  action_page_loaded as action_page_loaded_OyakProjeAyBazliToplamHakedis,
  action_page_unloaded as action_page_unloaded_OyakProjeAyBazliToplamHakedis,
  action_page_props_sent as action_page_props_sent_OyakProjeAyBazliToplamHakedis,
} from './container/page/OyakProjeAyBazliToplamHakedisAction';
import {
  action_page_loaded as action_page_loaded_Oyak,
  action_page_unloaded as action_page_unloaded_Oyak,
  action_page_props_sent as action_page_props_sent_Oyak,
} from './container/page/OyakAction';
import {
  action_page_loaded as action_page_loaded_Projeler,
  action_page_unloaded as action_page_unloaded_Projeler,
  action_page_props_sent as action_page_props_sent_Projeler,
} from './container/page/ProjelerAction';
import {
  action_page_loaded as action_page_loaded_Sorgula,
  action_page_unloaded as action_page_unloaded_Sorgula,
  action_page_props_sent as action_page_props_sent_Sorgula,
} from './container/page/SorgulaAction';
import {
  action_page_loaded as action_page_loaded_TasinmazBilgileri,
  action_page_unloaded as action_page_unloaded_TasinmazBilgileri,
  action_page_props_sent as action_page_props_sent_TasinmazBilgileri,
} from './container/page/TasinmazBilgileriAction';
import {
  action_page_loaded as action_page_loaded_OyakDegerlemeBilgileri,
  action_page_unloaded as action_page_unloaded_OyakDegerlemeBilgileri,
  action_page_props_sent as action_page_props_sent_OyakDegerlemeBilgileri,
} from './container/page/OyakDegerlemeBilgileriAction';

import {
  action_page_loaded as action_page_loaded_OyakKiraBilgileri,
  action_page_unloaded as action_page_unloaded_OyakKiraBilgileri,
  action_page_props_sent as action_page_props_sent_OyakKiraBilgileri,
} from './container/page/OyakKiraBilgileriAction';

import {
  action_async_start as action_async_start_YurtDisiTasinmazGenelBilgi,
  action_async_complete as action_async_complete_YurtDisiTasinmazGenelBilgi,
} from './container/api/bilgi/YurtDisiTasinmazlariGenelBilgiAction';

import {
  action_async_start as action_async_start_YurtDisiTasinmazBilgi,
  action_async_complete as action_async_complete_YurtDisiTasinmazBilgi,
} from './container/api/bilgi/YurtDisiTasinmazlariBilgiAction';

import {
  action_async_start as action_async_start_OyakKiraTrGeneliKirayaVerilenTasinmazlar,
  action_async_complete as action_async_complete_OyakKiraTrGeneliKirayaVerilenTasinmazlar,
  action_api_set_input as action_api_set_input_OyakKiraTrGeneliKirayaVerilenTasinmazlar,
} from './container/api/bilgi/OyakKiraTrGeneliKirayaVerilenTasinmazlarAction';

import {
  action_async_start as action_async_start_OyakKiraTrGeneliYillikGelirDagilimiListele,
  action_async_complete as action_async_complete_OyakKiraTrGeneliYillikGelirDagilimiListele,
} from './container/api/stat/OyakKiraTrGeneliYillikGelirDagilimiListeleAction';

import {
  action_async_start as action_async_start_OyakKiraTrGeneliAylikGelirDagilimiListele,
  action_async_complete as action_async_complete_OyakKiraTrGeneliAylikGelirDagilimiListele,
} from './container/api/stat/OyakKiraTrGeneliAylikGelirDagilimiListeleAction';

import {
  action_page_loaded as action_page_loaded_OyakKiraKirayaVerilenTasinmazlar,
  action_page_unloaded as action_page_unloaded_OyakKiraKirayaVerilenTasinmazlar,
  action_page_props_sent as action_page_props_sent_OyakKiraKirayaVerilenTasinmazlar,
} from './container/page/OyakKiraKirayaVerilenTasinmazlarAction';

import {
  action_page_loaded as action_page_loaded_OyakKiraTrGeneliYillikGelirDagilimi,
  action_page_unloaded as action_page_unloaded_OyakKiraTrGeneliYillikGelirDagilimi,
  action_page_props_sent as action_page_props_sent_OyakKiraTrGeneliYillikGelirDagilimi,
} from './container/page/OyakKiraTrGeneliYillikGelirDagilimiAction';

import {
  action_page_loaded as action_page_loaded_OyakKiraTrGeneliAylikGelirDagilimi,
  action_page_unloaded as action_page_unloaded_OyakKiraTrGeneliAylikGelirDagilimi,
  action_page_props_sent as action_page_props_sent_OyakKiraTrGeneliAylikGelirDagilimi,
} from './container/page/OyakKiraTrGeneliAylikGelirDagilimiAction';

export default {
  Api: {
    User: {
      Login: {
        setInput: action_api_set_input_OturumAc,
        resetStore: action_api_reset_store_OturumAc,
        asyncStart: action_async_start_promise_OturumAc,
        asyncComplete: action_async_complete_api_OturumAc,
      },
      Logout: {
        asyncStart: action_async_start_promise_OturumKapat,
        asyncComplete: action_async_complete_api_OturumKapat,
      },
      KullaniciKontrol: {
        setInput: action_api_set_input_KullaniciKontrol,
        asyncStart: action_async_start_promise_KullaniciKontrol,
        asyncComplete: action_async_complete_api_KullaniciKontrol,
      },
      OtpAl: {
        setInput: action_api_set_input_OtpAl,
        asyncStart: action_async_start_promise_OtpAl,
        asyncComplete: action_async_complete_api_OtpAl,
      },
      OtpKontrol: {
        setInput: action_api_set_input_OtpKontrol,
        asyncStart: action_async_start_promise_OtpKontrol,
        asyncComplete: action_async_complete_api_OtpKontrol,
      },
      SifremiUnuttum: {
        setInput: action_api_set_input_SifremiUnuttum,
        asyncStart: action_async_start_promise_SifremiUnuttum,
        asyncComplete: action_async_complete_api_SifremiUnuttum,
      },
      SifreDegistir: {
        setInput: action_api_set_input_SifreDegistir,
        asyncStart: action_async_start_promise_SifreDegistir,
        asyncComplete: action_async_complete_api_SifreDegistir,
      },
      UiVersionKontrol: {
        setInput: action_api_set_input_UiVersionKontrol,
        asyncStart: action_async_start_promise_UiVersionKontrol,
        asyncComplete: action_async_complete_api_UiVersionKontrol,
      },
    },
    Veri: {
      SorguInputlari: {
        asyncStart: action_async_start_promise_SorguInputlari,
        asyncComplete: action_async_complete_api_SorguInputlari,
      },
      GrupSirketListele: {
        asyncStart: action_async_start_promise_GrupSirketListele,
        asyncComplete: action_async_complete_api_GrupSirketListele,
      },
      FaaliyetAlaniListesi: {
        asyncStart: action_async_start_promise_FaaliyetAlaniListesi,
        asyncComplete: action_async_complete_api_FaaliyetAlaniListesi,
      },
      HaritadaAra: {
        asyncStart: action_async_start_promise_HaritadaAra,
        asyncComplete: action_async_complete_api_HaritadaAra,
      },
      ProjeListele: {
        asyncStart: action_async_start_promise_ProjeListele,
        asyncComplete: action_async_complete_api_ProjeListele,
      },
      RaporUrlGetir: {
        asyncStart: action_async_start_promise_RaporUrlGetir,
        asyncComplete: action_async_complete_api_RaporUrlGetir,
      },
    },
    Bilgi: {
      Anasayfa: {
        asyncStart: action_async_start_AnasayfaUstBilgi,
        asyncComplete: action_async_complete_AnasayfaUstBilgi,
      },
      FaaliyetAlani: {
        asyncStart: action_async_start_FaaliyetAlaniUstBilgi,
        asyncComplete: action_async_complete_FaaliyetAlaniUstBilgi,
      },
      GrupSirketi: {
        asyncStart: action_async_start_GrupSirketiUstBilgi,
        asyncComplete: action_async_complete_GrupSirketiUstBilgi,
      },
      KiraBilgi: {
        asyncStart: action_async_start_KiraBilgi,
        asyncComplete: action_async_complete_KiraBilgi,
      },
      KiraGenelBilgi: {
        asyncStart: action_async_start_KiraGenelBilgi,
        asyncComplete: action_async_complete_KiraGenelBilgi,
      },
      MadenSahalariBilgi: {
        asyncStart: action_async_start_MadenSahalariBilgi,
        asyncComplete: action_async_complete_MadenSahalariBilgi,
      },
      OyakGmCiroBazliListe: {
        asyncStart: action_async_start_OyakGmCiroBazliListe,
        asyncComplete: action_async_complete_OyakGmCiroBazliListe,
      },
      SorgulamaSonuclariListe: {
        asyncStart: action_async_start_SorgulamaSonuclariListe,
        asyncComplete: action_async_complete_SorgulamaSonuclariListe,
      },
      TiklamaSonuclariListe: {
        asyncStart: action_async_start_TiklamaSonuclariListe,
        asyncComplete: action_async_complete_TiklamaSonuclariListe,
      },
      OyakProjeToplamHakedisListe: {
        asyncStart: action_async_start_OyakProjeToplamHakedisListe,
        asyncComplete: action_async_complete_OyakProjeToplamHakedisListe,
      },
      MadenSahalariGenelBilgi: {
        asyncStart: action_async_start_MadenSahalariGenelBilgi,
        asyncComplete: action_async_complete_MadenSahalariGenelBilgi,
      },
      OyakKiraBilgileriUstBilgi: {
        asyncStart: action_async_start_OyakKiraBilgileriUstBilgi,
        asyncComplete: action_async_complete_OyakKiraBilgileriUstBilgi,
      },
      OyakKiraBilgileriUstBilgiKvtDetay: {
        asyncStart: action_async_start_OyakKiraBilgileriUstBilgiKvtDetay,
        asyncComplete: action_async_complete_OyakKiraBilgileriUstBilgiKvtDetay,
      },
      OyakKiraBilgileriUstBilgiYkgDetay: {
        asyncStart: action_async_start_OyakKiraBilgileriUstBilgiYkgDetay,
        asyncComplete: action_async_complete_OyakKiraBilgileriUstBilgiYkgDetay,
      },
      OyakKiraBilgileriUstBilgiAkgDetay: {
        asyncStart: action_async_start_OyakKiraBilgileriUstBilgiAkgDetay,
        asyncComplete: action_async_complete_OyakKiraBilgileriUstBilgiAkgDetay,
      },
      YurtDisiTasinmazlariGenelBilgi: {
        asyncStart: action_async_start_YurtDisiTasinmazGenelBilgi,
        asyncComplete: action_async_complete_YurtDisiTasinmazGenelBilgi,
      },
      OyakKiraTrGeneliKirayaVerilenTasinmazlar: {
        setInput: action_api_set_input_OyakKiraTrGeneliKirayaVerilenTasinmazlar,
        asyncStart: action_async_start_OyakKiraTrGeneliKirayaVerilenTasinmazlar,
        asyncComplete: action_async_complete_OyakKiraTrGeneliKirayaVerilenTasinmazlar,
      },
      YurtDisiTasinmazlariBilgi: {
        asyncStart: action_async_start_YurtDisiTasinmazBilgi,
        asyncComplete: action_async_complete_YurtDisiTasinmazBilgi,
      },
      GrupSirketDegerlemeUstBilgi: {
        asyncStart: action_async_start_GrupSirketDegerlemeUstBilgi,
        asyncComplete: action_async_complete_GrupSirketDegerlemeUstBilgi,
      },
      OyakDegerlemeUstBilgi: {
        asyncStart: action_async_start_OyakDegerlemeUstBilgi,
        asyncComplete: action_async_complete_OyakDegerlemeUstBilgi,
      },
      UstBilgiIstatistikDetay: {
        asyncStart: action_async_start_UstBilgiIstatistikDetay,
        asyncComplete: action_async_complete_UstBilgiIstatistikDetay,
      },
    },
    Stat: {
      GayrimenkulToplamDeger: {
        KullanimAmacli: {
          setInput: action_api_set_input_KullanimAmacliGayrimenkulToplamDeger,
          asyncStart: action_async_start_promise_KullanimAmacliGayrimenkulToplamDeger,
          asyncComplete: action_async_complete_api_KullanimAmacliGayrimenkulToplamDeger,
        },
        YatirimAmacli: {
          setInput: action_api_set_input_YatirimAmacliGayrimenkulToplamDeger,
          asyncStart: action_async_start_promise_YatirimAmacliGayrimenkulToplamDeger,
          asyncComplete: action_async_complete_api_YatirimAmacliGayrimenkulToplamDeger,
        },
        Toplam: {
          setInput: action_api_set_input_GayrimenkulToplamDeger,
          asyncStart: action_async_start_promise_GayrimenkulToplamDeger,
          asyncComplete: action_async_complete_api_GayrimenkulToplamDeger,
        },
      },
      GayrimenkulAlan: {
        KullanimAmacli: {
          setInput: action_api_set_input_KullanimAmacliGayrimenkulAlan,
          asyncStart: action_async_start_promise_KullanimAmacliGayrimenkulAlan,
          asyncComplete: action_async_complete_api_KullanimAmacliGayrimenkulAlan,
        },
        YatirimAmacli: {
          setInput: action_api_set_input_YatirimAmacliGayrimenkulAlan,
          asyncStart: action_async_start_promise_YatirimAmacliGayrimenkulAlan,
          asyncComplete: action_async_complete_api_YatirimAmacliGayrimenkulAlan,
        },
        Toplam: {
          setInput: action_api_set_input_GayrimenkulAlan,
          asyncStart: action_async_start_promise_GayrimenkulAlan,
          asyncComplete: action_async_complete_api_GayrimenkulAlan,
        },
      },
      GayrimenkulSayi: {
        KullanimAmacli: {
          setInput: action_api_set_input_KullanimAmacliGayrimenkulSayi,
          asyncStart: action_async_start_promise_KullanimAmacliGayrimenkulSayi,
          asyncComplete: action_async_complete_api_KullanimAmacliGayrimenkulSayi,
        },
        YatirimAmacli: {
          setInput: action_api_set_input_YatirimAmacliGayrimenkulSayi,
          asyncStart: action_async_start_promise_YatirimAmacliGayrimenkulSayi,
          asyncComplete: action_async_complete_api_YatirimAmacliGayrimenkulSayi,
        },
        Toplam: {
          setInput: action_api_set_input_GayrimenkulSayi,
          asyncStart: action_async_start_promise_GayrimenkulSayi,
          asyncComplete: action_async_complete_api_GayrimenkulSayi,
        },
      },
      OyakEmlakVergileri: {
        setInput: action_api_set_input_OyakEmlakVergileri,
        asyncStart: action_async_start_OyakEmlakVergileri,
        asyncComplete: action_async_complete_OyakEmlakVergileri,
      },
      Degerleme: {
        Toplam: {
          setInput: action_api_set_input_DegerlemeToplamDeger,
          asyncStart: action_async_start_promise_DegerlemeToplamDeger,
          asyncComplete: action_async_complete_api_DegerlemeToplamDeger,
        },
      },
      OyakDegerleme: {
        Toplam: {
          setInput: action_api_set_input_OyakDegerlemeToplamDeger,
          asyncStart: action_async_start_promise_OyakDegerlemeToplamDeger,
          asyncComplete: action_async_complete_api_OyakDegerlemeToplamDeger,
        },
      },
      OyakKiraTrGeneliYillikGelirDagilimiListele: {
        asyncStart: action_async_start_OyakKiraTrGeneliYillikGelirDagilimiListele,
        asyncComplete: action_async_complete_OyakKiraTrGeneliYillikGelirDagilimiListele,
      },
      OyakKiraTrGeneliAylikGelirDagilimiListele: {
        asyncStart: action_async_start_OyakKiraTrGeneliAylikGelirDagilimiListele,
        asyncComplete: action_async_complete_OyakKiraTrGeneliAylikGelirDagilimiListele,
      },
      OyakEmlakVergileriDetayToplamDeger: {
        asyncStart: action_async_start_OyakEmlakVergileriDetayToplamDeger,
        asyncComplete: action_async_complete_OyakEmlakVergileriDetayToplamDeger,
      },
    },
  },
  Page: {
    Dashboard: {
      pageLoaded: action_page_loaded_Dashboard,
      pageUnloaded: action_page_unloaded_Dashboard,
      propsSent: action_page_props_sent_Dashboard,
    },
    DegerlemeBilgileri: {
      pageLoaded: action_page_loaded_DegerlemeBilgileri,
      pageUnloaded: action_page_unloaded_DegerlemeBilgileri,
      propsSent: action_page_props_sent_DegerlemeBilgileri,
    },
    EmlakVergileri: {
      pageLoaded: action_page_loaded_EmlakVergileri,
      pageUnloaded: action_page_unloaded_EmlakVergileri,
      propsSent: action_page_props_sent_EmlakVergileri,
    },
    FourOhFour: {
      pageLoaded: action_page_loaded_FourOhFour,
      pageUnloaded: action_page_unloaded_FourOhFour,
      propsSent: action_page_props_sent_FourOhFour,
    },
    FaaliyetAlani: {
      pageLoaded: action_page_loaded_FaaliyetAlani,
      pageUnloaded: action_page_unloaded_FaaliyetAlani,
      propsSent: action_page_props_sent_FaaliyetAlani,
    },
    GayrimenkulAlan: {
      pageLoaded: action_page_loaded_GayrimenkulAlan,
      pageUnloaded: action_page_unloaded_GayrimenkulAlan,
      propsSent: action_page_props_sent_GayrimenkulAlan,
    },
    GayrimenkulSayi: {
      pageLoaded: action_page_loaded_GayrimenkulSayi,
      pageUnloaded: action_page_unloaded_GayrimenkulSayi,
      propsSent: action_page_props_sent_GayrimenkulSayi,
    },
    GayrimenkulToplamDeger: {
      pageLoaded: action_page_loaded_GayrimenkulToplamDeger,
      pageUnloaded: action_page_unloaded_GayrimenkulToplamDeger,
      propsSent: action_page_props_sent_GayrimenkulToplamDeger,
    },
    GrupSirketi: {
      pageLoaded: action_page_loaded_GrupSirketi,
      pageUnloaded: action_page_unloaded_GrupSirketi,
      propsSent: action_page_props_sent_GrupSirketi,
    },
    Harita: {
      pageLoaded: action_page_loaded_Harita,
      pageUnloaded: action_page_unloaded_Harita,
      propsSent: action_page_props_sent_Harita,
    },
    KiraBilgileri: {
      pageLoaded: action_page_loaded_KiraBilgileri,
      pageUnloaded: action_page_unloaded_KiraBilgileri,
      propsSent: action_page_props_sent_KiraBilgileri,
    },
    Kisisel: {
      pageLoaded: action_page_loaded_Kisisel,
      pageUnloaded: action_page_unloaded_Kisisel,
      propsSent: action_page_props_sent_Kisisel,
    },
    Login: {
      pageLoaded: action_page_loaded_Login,
      pageUnloaded: action_page_unloaded_Login,
      propsSent: action_page_props_sent_Login,
    },
    MadenSahalari: {
      pageLoaded: action_page_loaded_MadenSahalari,
      pageUnloaded: action_page_unloaded_MadenSahalari,
      propsSent: action_page_props_sent_MadenSahalari,
    },
    OyakGmCiroBazli: {
      pageLoaded: action_page_loaded_OyakGmCiroBazli,
      pageUnloaded: action_page_unloaded_OyakGmCiroBazli,
      propsSent: action_page_props_sent_OyakGmCiroBazli,
    },
    SorgulamaSonuclari: {
      pageLoaded: action_page_loaded_SorgulamaSonuclari,
      pageUnloaded: action_page_unloaded_SorgulamaSonuclari,
      propsSent: action_page_props_sent_SorgulamaSonuclari,
    },
    OyakProjeToplamHakedis: {
      pageLoaded: action_page_loaded_OyakProjeToplamHakedis,
      pageUnloaded: action_page_unloaded_OyakProjeToplamHakedis,
      propsSent: action_page_props_sent_OyakProjeToplamHakedis,
    },
    OyakProjeYilBazliToplamHakedis: {
      pageLoaded: action_page_loaded_OyakProjeYilBazliToplamHakedis,
      pageUnloaded: action_page_unloaded_OyakProjeYilBazliToplamHakedis,
      propsSent: action_page_props_sent_OyakProjeYilBazliToplamHakedis,
    },
    OyakProjeAyBazliToplamHakedis: {
      pageLoaded: action_page_loaded_OyakProjeAyBazliToplamHakedis,
      pageUnloaded: action_page_unloaded_OyakProjeAyBazliToplamHakedis,
      propsSent: action_page_props_sent_OyakProjeAyBazliToplamHakedis,
    },
    Oyak: {
      pageLoaded: action_page_loaded_Oyak,
      pageUnloaded: action_page_unloaded_Oyak,
      propsSent: action_page_props_sent_Oyak,
    },
    Projeler: {
      pageLoaded: action_page_loaded_Projeler,
      pageUnloaded: action_page_unloaded_Projeler,
      propsSent: action_page_props_sent_Projeler,
    },
    Sorgula: {
      pageLoaded: action_page_loaded_Sorgula,
      pageUnloaded: action_page_unloaded_Sorgula,
      propsSent: action_page_props_sent_Sorgula,
    },
    TasinmazBilgileri: {
      pageLoaded: action_page_loaded_TasinmazBilgileri,
      pageUnloaded: action_page_unloaded_TasinmazBilgileri,
      propsSent: action_page_props_sent_TasinmazBilgileri,
    },
    OyakKiraBilgileri: {
      pageLoaded: action_page_loaded_OyakKiraBilgileri,
      pageUnloaded: action_page_unloaded_OyakKiraBilgileri,
      propsSent: action_page_props_sent_OyakKiraBilgileri,
    },
    OyakKiraKirayaVerilenTasinmazlar: {
      pageLoaded: action_page_loaded_OyakKiraKirayaVerilenTasinmazlar,
      pageUnloaded: action_page_unloaded_OyakKiraKirayaVerilenTasinmazlar,
      propsSent: action_page_props_sent_OyakKiraKirayaVerilenTasinmazlar,
    },
    OyakDegerlemeBilgileri: {
      pageLoaded: action_page_loaded_OyakDegerlemeBilgileri,
      pageUnloaded: action_page_unloaded_OyakDegerlemeBilgileri,
      propsSent: action_page_props_sent_OyakDegerlemeBilgileri,
    },
    OyakKiraTrGeneliYillikGelirDagilimi: {
      pageLoaded: action_page_loaded_OyakKiraTrGeneliYillikGelirDagilimi,
      pageUnloaded: action_page_unloaded_OyakKiraTrGeneliYillikGelirDagilimi,
      propsSent: action_page_props_sent_OyakKiraTrGeneliYillikGelirDagilimi,
    },
    OyakKiraTrGeneliAylikGelirDagilimi: {
      pageLoaded: action_page_loaded_OyakKiraTrGeneliAylikGelirDagilimi,
      pageUnloaded: action_page_unloaded_OyakKiraTrGeneliAylikGelirDagilimi,
      propsSent: action_page_props_sent_OyakKiraTrGeneliAylikGelirDagilimi,
    },
  },
};
